import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';

import { TRACKING_LEAD_QUALITY } from './IwTracking.actions';
import {
    getValueOfLatestActiveSignupStepCookie,
    generateLatestActiveSignupStepCookie,
    SIGNUP_STEPS,
    NUMBER_OF_STEPS,
    ACCOUNT_PAGES_STEP_NUMBER
} from './IwTrackingHelpers';

function trackLatestActiveSignupStep({
    stepNumber,
    isImpersonating = false
} = {}) {
    GoogleTagManager.track('setLatestActiveSignupStep', {
        latestActiveSignupStep: stepNumber,
        isImpersonating
    });
}

export function setLatestActiveSignupStep(
    currentSignupStep,
    { isImpersonating = false } = {}
) {
    const latestActiveSignupStepCookieValue =
        getValueOfLatestActiveSignupStepCookie();

    const currentLatestSignupStepNumber = SIGNUP_STEPS.findIndex(
        (step) => step === currentSignupStep
    );

    const latestActiveSignupStepNumber = SIGNUP_STEPS.findIndex(
        (step) => step === latestActiveSignupStepCookieValue
    );

    const latestSignupStepCookieValue =
        SIGNUP_STEPS[
            Math.max(
                currentLatestSignupStepNumber,
                latestActiveSignupStepNumber
            )
        ];

    // Making sure the cookie gets always updated
    // Important if customer is using legacy cookie with a step number
    // Will convert step number to step-string
    document.cookie = generateLatestActiveSignupStepCookie({
        latestSignupStep: latestSignupStepCookieValue
    });

    if (currentLatestSignupStepNumber <= latestActiveSignupStepNumber) return;

    const latestActiveSignupStepPayload =
        currentLatestSignupStepNumber >= NUMBER_OF_STEPS
            ? ACCOUNT_PAGES_STEP_NUMBER
            : currentLatestSignupStepNumber;

    trackLatestActiveSignupStep({
        stepNumber: latestActiveSignupStepPayload,
        isImpersonating
    });
}

export function trackRedirectToAccountPages({ isImpersonating = false } = {}) {
    const latestActiveSignupStepCookieValue =
        getValueOfLatestActiveSignupStepCookie();

    if (latestActiveSignupStepCookieValue === SIGNUP_STEPS[NUMBER_OF_STEPS])
        return;

    document.cookie = generateLatestActiveSignupStepCookie({
        latestSignupStep: SIGNUP_STEPS[NUMBER_OF_STEPS]
    });

    trackLatestActiveSignupStep({
        stepNumber: ACCOUNT_PAGES_STEP_NUMBER,
        isImpersonating
    });
}

export function completeSignupStep(completedSignupStep) {
    const latestActiveSignupStepCookieValue =
        getValueOfLatestActiveSignupStepCookie();

    const currentLatestSignupStepNumber = SIGNUP_STEPS.findIndex(
        (step) => step === completedSignupStep
    );

    const latestActiveSignupStepNumber = SIGNUP_STEPS.findIndex(
        (step) => step === latestActiveSignupStepCookieValue
    );

    if (currentLatestSignupStepNumber < latestActiveSignupStepNumber) return;

    GoogleTagManager.trackEvent({
        event: 'Completed Signup Step',
        label: completedSignupStep
    });
}

const trackLeadQualityAction = (stepName) => ({
    type: TRACKING_LEAD_QUALITY,
    stepName
});

function setUserIdentifiers({ stateKey, requestedProductType, isIntroducer }) {
    GoogleTagManager.identifyUser(stateKey, {
        isIntroducer
    });

    GoogleTagManager.track('addedRequestedProductTypeToUser', {
        requestedProductType
    });
}

function trackBusinessIntroduction(businessTypeFields) {
    Object.keys(businessTypeFields).forEach((field) => {
        if (
            field === 'annual_turnover' ||
            field === 'online_sales_percentage' ||
            field === 'vat_registered_status' ||
            field === 'industry' ||
            field === 'annual_business_profit'
        ) {
            tracking.ampli.identify(undefined, {
                [field]: businessTypeFields[field]
            });
        }
    });
}

const IwTracking = {
    setLatestActiveSignupStep,
    trackRedirectToAccountPages,
    completeSignupStep,
    trackLeadQualityAction,
    setUserIdentifiers,
    trackBusinessIntroduction
};

export default IwTracking;
